import React from "react";
import { useTranslation } from "react-i18next";
import { IsRunningOverwolf } from "../utilityFunctions";
import { SendChangeLanguage } from "../overwolf/helper/windowCommunicationHelper";

interface LanguageSelectorPropsInterface {
  buttonScale?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorPropsInterface> = ({
  buttonScale,
}) => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (event: any) => {
    const newLanguage = event.target.value;
    i18n.changeLanguage(newLanguage);
    if (IsRunningOverwolf()) {
      SendChangeLanguage(newLanguage);
    }
  };

  return (
    <div>
      <label className="sr-only" htmlFor="react-select-2-input">
        Choose a language
      </label>
      <select
        className={`text-slate-300 bg-transparent cursor-pointer text-lg md:text-sm w-12 2xl:w-11 ${
          buttonScale ? buttonScale : "scale-110 2xl:scale-125"
        }`}
        id="lang"
        value={t("localization_testing")}
        onChange={changeLanguage}
      >
        <option className="text-slate-800 2xl:text-base" value="en">
          EN
        </option>
        <option className="text-slate-800 2xl:text-base" value="fr">
          FR
        </option>
      </select>
    </div>
  );
};
